<template>
  <div class="section">
    <h1 class="title">{{ user.fullName }}</h1>
    <h1 class="subtitle">
      Welcome to the admin panel
      <button class="button logout is-text" @click="logout">
        <span class="icon is-small">
          <i class="fas fa-sign-out-alt"></i>
        </span>
        <span>Logout</span>
      </button>
    </h1>

    <div class="container is-fluid">
      <div class="tabs is-boxed is-centered">
        <ul>
          <li
            v-for="(tab, i) in tabs"
            :key="i"
            :class="[tab.isActive ? 'is-active' : '']"
          >
            <a @click="SET_ACTIVE_TAB(tab.table)" v-html="tab.name"></a>
          </li>
        </ul>
      </div>
      <component :is="activeTab.childComponent" />
    </div>
    <Pagination size="10" start="1" />
    <ModalManager />
  </div>
</template>

<script>
import Dashboard from "../components/Dashboard/Dashboard.vue";
import userList from "../components/UserList.vue";
import companyList from "../components/CompanyList.vue";
import projectList from "../components/ProjectList.vue";
import cameraList from "../components/CameraList.vue";
import Pagination from "../components/Pagination.vue";
import contractList from "../components/ContractList.vue";
import videoOrderList from "../components/VideoOrderList.vue";
import proCameraInventoryList from "../components/ProCameraInventoryList.vue";
import ModalManager from "../components/ModalManager.vue";
import ComponentList from "@/components/ComponentList.vue";

import { mapState, mapGetters, mapMutations, mapActions } from "vuex";

export default {
  components: {
    ComponentList,
    Dashboard,
    userList,
    companyList,
    projectList,
    cameraList,
    contractList,
    videoOrderList,
    proCameraInventoryList,
    ModalManager,
    Pagination,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(["user", "tabs"]),
    ...mapGetters(["activeTab", "availableTabs"]),
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["SET_ACTIVE_TAB"]),
  },
  mounted() {},
};
</script>

<style scoped>
.button.logout {
  margin-top: -0.5rem;
}
</style>
